import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { SchoolYearService } from '../../services/date-manager/school-year/school-year.service';

@Directive({
    selector: '[appSchoolYearDisabled]'
})
export class SchoolYearDisabledActionDirective implements OnInit {
    @Input() appSchoolYearDisabled = 'hidden';
    constructor(
        private el: ElementRef,
        private schoolYearService: SchoolYearService
    ) {}

    public ngOnInit() {
        if (!this.schoolYearService.isCurrentSchoolYearSelected()) {
            if (this.appSchoolYearDisabled === 'disabled') {
                this.el.nativeElement.setAttribute('disabled', 'disabled');
            } else {
                this.el.nativeElement.hidden = true;
                if (this.el.nativeElement.type === 'checkbox') {
                    this.el.nativeElement.setAttribute('disabled', 'disabled');
                }

                // Disable icon selector. this is for preference roster
                if (this.el.nativeElement.className === 'icon-selector') {
                    this.el.nativeElement.hidden = false;
                    this.el.nativeElement.classList.add('disabled');
                    this.el.nativeElement.style.cursor = 'not-allowed';

                    // Find the toggleBtn child element
                    const toggleBtn = this.el.nativeElement.querySelector('.toggleBtn');
                    if (toggleBtn) {
                        // Remove click functionality
                        toggleBtn.style.pointerEvents = 'none';
                        toggleBtn.setAttribute('disabled', 'disabled');
                    }
                }
            }
        }
    }
}
